<template>
    <button class="text-white font-semibold rounded shadow"
            :disabled="disabled"
            :class="classes()"
            v-on="$listeners">
        <slot></slot>
    </button>
</template>

<script>

    export default {
        props: {
            size: {
                type: String,
                default: 'md'
            },
            block: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'primary'
            }
        },
        methods: {
            classes() {
                let paddingMap = {
                    xs: 'py-1 px-6',
                    sm: 'py-1 px-8',
                    md: 'py-2 px-10',
                    lg: 'py-4 px-12',
                };
                let textSizesMap = {
                    xs: 'text-xs',
                    sm: 'text-sm',
                    md: 'text-base',
                    lg: 'text-lg',
                };

                let colorMap = {
                    primary: 'primary',
                    danger: 'red',
                    default: 'gray',

                }
                let color = colorMap[this.type];

                let padding = paddingMap[this.size];
                let text = textSizesMap[this.size];
                let width = this.block ? 'w-full' : 'w-auto';
                let disabled = this.disabled ? `bg-${color}-300 cursor-not-allowed` : `bg-${color}-500 hover:bg-${color}-600`;
                return `${text} ${padding} ${width} ${disabled}`
            },
        }
    }
</script>
